module.exports = __webpack_public_path__ + "img/success.bb26ae46.svg";